// extracted by mini-css-extract-plugin
export default {"edit":"Edit_edit__9WHjA"};